
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 11 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 3.478v8.943c0 .823.668 1.49 1.49 1.49h5.962a.497.497 0 000-.993H1.49a.497.497 0 01-.497-.497V3.974h1.49a1.49 1.49 0 001.49-1.49V.994H9.44c.274 0 .496.224.496.497v3.404a.497.497 0 00.993 0V1.49A1.49 1.49 0 009.438 0h-5.96c-.133 0-.26.05-.354.145l-2.98 2.98A.497.497 0 000 3.478zm2.484-.497h-.79l1.287-1.286v.79a.497.497 0 01-.497.496z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.855 3.478c0 .275.223.496.497.496h3.032a.497.497 0 000-.993H5.352a.497.497 0 00-.497.497zM2.422 5.962c0 .275.223.497.496.497H7.44a.497.497 0 000-.994H2.918a.497.497 0 00-.496.497zM2.422 8.445c0 .275.223.497.496.497H5.25a.497.497 0 000-.993H2.918a.497.497 0 00-.496.496zM2.422 10.93c0 .275.223.496.496.496h2.778a.497.497 0 000-.993H2.918a.497.497 0 00-.496.497z","fill":"currentColor"}})])
          )
        }
      }
    